module.exports = __webpack_public_path__ + "img/send.7c1f4734.svg";